import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import axiosInstance from "../utils/axiosConfig";
import { useAuth } from "../contexts/auth";
import { fetchAuthToken } from "../utils/getCognitoToken";

export const ConsentCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { onLogin } = useAuth();
  const [error, setError] = useState("");
  const hasRun = useRef(false); // StrictMode mounts twice; SLT is single-use

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const slt = searchParams.get("slt");
    if (!slt) {
      setError("Invalid login link.");
      return;
    }

    axiosInstance()
      .post("auth/consent/exchange-token", {
        slt,
        requestId: "req" + Date.now(),
      })
      .then(async (res) => {
        if (res.data.code === 200) {
          const appAccessToken = await fetchAuthToken();
          if (!appAccessToken) {
            toast.error("Could not establish a secure session. Please try again.", { position: "top-center" });
            setError("Could not establish a secure session.");
            return;
          }
          localStorage.setItem("access_token", appAccessToken);
          onLogin(res.data.data);
        } else {
          toast.error(res.data.message || "Login link is invalid or has expired.", { position: "top-center" });
          setError(res.data.message || "Login link is invalid or has expired.");
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(err?.message || "Something went wrong", { position: "top-center" });
        setError("Something went wrong while signing you in.");
      });
  }, [searchParams, onLogin]);

  return (
    <Container fluid className="px-4 py-5">
      <Row className="justify-content-center text-center">
        <Col md={6}>
          {error ? (
            <>
              <p className="mb-3">{error}</p>
              <button className="btn btn-primary" onClick={() => navigate("/consent-login", { replace: true })}>
                Back to Login
              </button>
            </>
          ) : (
            <>
              <Spinner animation="border" role="status" className="mb-3" />
              <p>Signing you in…</p>
            </>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default ConsentCallback;
